import { isObject } from "lodash-es";
import { ErrorParser } from "../ErrorParser";

/**
 * Ej: 'This field may not be blank.'
 */
export class CampoVacioParser implements ErrorParser {
    private readonly camposTraducidos = {
        friendly_name: "nombre amigable"
    };

    public puedeLeerError(error: { [key: string]: string[] }): boolean {
        if (!isObject(error)) {
            return false;
        }
        return Object.values(error).some(valor => valor[0].includes("This field may not be blank"));
    }

    public traducir(error: { [key: string]: string[] }): string {
        const traduccion: string = this.camposTraducidos[Object.keys(error)[0]];
        return `El campo ${traduccion ?? Object.keys(error)[0]} esta vacio`;
    }

}
